import jwt from 'jsonwebtoken';
import enrollmentActions from './enrollmentAction';
import steps from '../../domain/EnrollmentPage/steps';
import stepsEnrollmentLegal from '../../domain/EnrollmentLegal/steps';
// COMENTARIO
function setAuthToken(state, action) {
  const token = action.payload;
  sessionStorage.setItem('vantrust.token', token);

  const { id, figureType } = jwt.decode(token);

  return { ...state, authToken: token, figureType, enrollmentId: id };
}

function removeAuthToken(state) {
  sessionStorage.removeItem('vantrust.token');
  sessionStorage.removeItem('postulant-email');

  return {
    ...state,
    authToken: undefined,
    enrollmentForm: {
      contact: {},
    },
    isStepShrunken: false,
    isStepExpanded: false,
    currentStepIndex: 0,
    currentStep: steps[0],
    lastStepIndex: 0,
  };
}

function handleSetStepData(state, action) {
  const data = action.payload;

  return {
    ...state,
    enrollmentForm: {
      ...state.enrollmentForm,
      [`step${state.currentStepIndex}`]: data,
    },
  };
}

function handleSetPartialStepData(state, action) {
  const data = action.payload;

  return {
    ...state,
    enrollmentForm: {
      ...state.enrollmentForm,
      [`step${state.currentStepIndex}`]: {
        ...state.enrollmentForm[`step${state.currentStepIndex}`],
        ...data,
      },
    },
  };
}

function handleSetStep(state, action, typeForm) {
  const stepsArray = typeForm === 'enrollment' ? steps : stepsEnrollmentLegal;
  const step = Math.max(0, Math.min(action.payload || 0, stepsArray.length - 1));
  const currentStepIndex =
    typeForm === 'enrollment' ? 'currentStepIndex' : 'currentStepEnrollmentLegalIndex';
  const currentStep = typeForm === 'enrollment' ? 'currentStep' : 'currentStepEnrollmentLegal';

  if (step === state[currentStepIndex]) {
    return { ...state };
  }

  return {
    ...state,
    [currentStepIndex]: step,
    [currentStep]: stepsArray[step],
    isStepShrunken: false,
    isStepExpanded: false,
  };
}

export default function enrollmentReducer(state, action) {
  switch (action.type) {
    case enrollmentActions.SET_CONTACT_INFO:
      return {
        ...state,
        enrollmentForm: {
          ...state.enrollmentForm,
          contact: action.payload,
        },
      };
    case enrollmentActions.SET_ENROLLMENT:
      return { ...state, enrollment: action.payload };
    case enrollmentActions.SET_STEP_DATA:
      return handleSetStepData(state, action);
    case enrollmentActions.SET_PARTIAL_STEP_DATA:
      return handleSetPartialStepData(state, action);
    case enrollmentActions.SET_POSTULANT_EMAIL:
      sessionStorage.setItem('postulant-email', action.payload);

      return {
        ...state,
        postulantEmail: action.payload,
      };
    case enrollmentActions.SET_POSTULANT_RUT:
      sessionStorage.setItem('postulant-rut', action.payload);

      return {
        ...state,
        postulantRut: action.payload,
      };
    case enrollmentActions.SET_AUTH_TOKEN:
      return setAuthToken(state, action);
    case enrollmentActions.REMOVE_AUTH_TOKEN:
      return removeAuthToken(state);
    case enrollmentActions.SET_STEP_INDEX:
      return handleSetStep(state, action, 'enrollment');
    case enrollmentActions.SET_STEP_ENROLLMENT_LEGAL_INDEX:
      return handleSetStep(state, action, 'enrollmentLegal');
    case enrollmentActions.SHRINK_STEP:
      return {
        ...state,
        isStepShrunken: true,
        isStepExpanded: false,
      };
    case enrollmentActions.EXPAND_STEP:
      return {
        ...state,
        isStepShrunken: false,
        isStepExpanded: true,
      };
    case enrollmentActions.SET_TRACKING_NUMBER:
      return {
        ...state,
        trackingNumber: action.payload,
      };
    case enrollmentActions.GO_TO_VIEW:
      return {
        ...state,
        currentView: action.payload,
      };
    case enrollmentActions.ACCEPT_LEGAL_BACKGROUND_INSTRUCCTIONS:
      return {
        ...state,
        areLegalBackgroundInstructionRead: true,
      };
    case enrollmentActions.ACCEPT_UAF_INSTRUCTIONS:
      return {
        ...state,
        areUafInstructionsRead: true,
      };
    default:
      return state;
  }
}
